import React, { useEffect, useState, useRef } from 'react';
import nigeria from '../../images/icons/nigeria.svg'
import sa from '../../images/icons/sa.svg'
import heroright from '../../images/heroright.svg'
import homeHero from '../../images/HomeHero.svg'
import CustomCarousel from '../../components/carousel';
import Card from '../../components/Card';
import filter from '../../images/icons/filter.svg'
import axios from 'axios'
import { ColorRing } from 'react-loader-spinner'
import searchIcon from '../../images/icons/search.svg'
import toright from '../../images/icons/toright.svg'
import toleft from '../../images/icons/toleft.svg'

function HomeBody(props) {
    const [categories, setCategories] = useState([
    ])

    const [cards, setCards] = useState([

    ])

    const navigateToCategory = (category) => {
        sessionStorage.setItem('categoryId',category.id)
        sessionStorage.setItem('currentCategory',category.categoryName)
        window.location.href='/businesses'
    }

    const scrollRef = useRef(null);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);

    const checkScroll = () => {
    if (!scrollRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
        setShowLeft(scrollLeft > 0);
        setShowRight(scrollLeft + clientWidth < scrollWidth);
    };

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        checkScroll();
        setTimeout(checkScroll, 0);
        const handleResize = () => checkScroll();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [categories]);

    const scroll = (direction) => {
        if (!scrollRef.current) return;
        const amount = 200; // how much to scroll each click
        scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
        });
    };

  
    async function filterBusinesses(country) {
        setFetched(0)
        setShowFilter(0)
        axios.get(process.env.REACT_APP_BASE_URL+'/Business/RecentAdditions/500/1',{})
        .then((res2) => {
            if(res2.status == 200){
                setCards(res2.data.data.items.filter(businesses => businesses.userCountry === country));
                setFetched(1)
            }
            })
        .then(() => {
            sessionStorage.setItem('searchQuery','')
        }).catch((e) => {
            console.log(e)
        })
    }
    let [fetched, setFetched] = useState()
     const [country, setCountry] = useState(sessionStorage.getItem('userCountry') || '');
    useEffect(() => {
        axios.get(process.env.REACT_APP_BASE_URL+'/Category/GetTopLevel',{})
        .then((res) => {
            if(res.status == 200){
                setCategories(res.data.data)
            }}
        ).then(() => {
            let url = sessionStorage.getItem('searchQuery') ? '/search?query='+sessionStorage.getItem('searchQuery') : '/Business/RecentAdditions/500/1'
            if(!country){
                fetch('https://ipinfo.io/json?token=98b21ec2ff9bf7')
                .then(res => res.json())
                .then(data => {
                    const userCountry = data.country == 'ZA' ? 'South Africa' : 'Nigeria';
                    setCountry(userCountry);
                    sessionStorage.setItem('userCountry', userCountry);
                    axios.get(process.env.REACT_APP_BASE_URL+url,{})
                    .then((res2) => {
                        if(res2.status == 200){
                            setCards(sessionStorage.getItem('searchQuery') ? res2.data.data.filter(businesses => businesses.userCountry === userCountry) : res2.data.data.items.filter(businesses => businesses.userCountry === userCountry))
                            setFetched(1) 
                        }
                        }).then(() => {
                    sessionStorage.removeItem('searchQuery')
                })
                })
            }else{
                axios.get(process.env.REACT_APP_BASE_URL+url,{})
                .then((res2) => {
                    if(res2.status == 200){
                        console.log(sessionStorage.getItem('searchQuery'))
                        setCards(sessionStorage.getItem('searchQuery') ? res2.data.data.filter(businesses => businesses.userCountry === country) : res2.data.data.items.filter(businesses => businesses.userCountry === country))
                        setFetched(1) 
                    }
                }).then(() => {
                    sessionStorage.removeItem('searchQuery')
                })
            }

        })
        .catch((e) => {
            console.log(e)
        })
    }, [country])

    const [searchQuery, setSearchchQuery] = useState()
    const makeSearch = (e) => {
        e.preventDefault()
        sessionStorage.setItem('searchQuery',searchQuery)
        window.location.href=''
    }

    const [showFilter, setShowFilter] = useState()
    return (
        <div className='p-5 lg:p-20 lg:pt-10 grid'>
            <section className="relative mx-auto overflow-hidden rounded-[16px] bg-[#008B39] text-white">
                <img src={homeHero} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover" />
                <div className="relative grid items-center gap-8 px-5 py-8 sm:px-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(260px,0.85fr)] lg:px-10 lg:py-8 xl:min-h-[560px] xl:px-12 2xl:min-h-[640px]">
                <div className='flex max-w-[640px] flex-col items-start space-y-5 text-start'>
                    <h1 data-wow-duration="2s" className='font-[700] wow fadeInUp text-[28px] leading-[1.15] sm:text-[40px] lg:text-[52px] xl:text-[64px] xl:leading-[1.1]'>
                        Get the Positive<br className="hidden sm:block" /> Recommendations<br className="hidden sm:block" /> Your Business<br className="hidden sm:block" /> Deserves
                        </h1>
                    <p data-wow-duration="2s" data-wow-delay='.2s' className='max-w-[520px] text-base wow fadeInUp font-[400] text-white/95 sm:text-lg lg:text-[20px]'>Build your reputation, attract more clients, and watch your business thrive with recommendations.</p>
                    <div className='relative w-full max-w-[560px]'>
                        <form data-wow-duration="2s" data-wow-delay='.5s' className='relative wow fadeInUp' onSubmit={makeSearch}>
                            <span className='pointer-events-none absolute left-4 top-1/2 z-10 -translate-y-1/2'><img src={searchIcon} alt="" /></span>
                            <input onChange={(e) => setSearchchQuery(e.target.value)} className='h-[52px] w-full rounded-[32px] bg-white pl-11 pr-[108px] text-black outline-none ring-white/80 focus:ring-2' placeholder='Search business name'/>
                            <button type="submit" className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-full bg-[#008B39] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#0C6F35] active:scale-[0.98]">Search</button>
                            {/* <button onClick={() => setShowFilter(!showFilter)} type='button' className='absolute rounded-[30px] left-[58%] lg:left-[52%] top-[0px] pl-10 ml-5 py-1'><img src={filter} /></button> */}
                        </form>
                        {showFilter ? <div className='rounded-[8px] flex flex-col bg-white w-full lg:w-[30%] lg:ml-60 mt-2 text-[#242424] sticky'>
                            <div onClick={() => filterBusinesses('Nigeria')} className='flex flex-row space-x-6 cursor-pointer hover:bg-gray-200 px-2 py-2 pb-1 rounded-t-[8px]'>
                                <span className=''><img src={nigeria} /></span>
                                <span>Nigeria</span>
                            </div>
                            <div onClick={() => filterBusinesses('South Africa')} className='flex flex-row space-x-6 cursor-pointer hover:bg-gray-200 px-2 py-2 pt-1 rounded-b-[8px]'>
                                <span className=''><img src={sa} /></span>
                                <span>South Africa</span>
                            </div>
                        </div> : ''}
                    </div>
                </div>
                <div data-wow-duration="2s" data-wow-delay='.8s' className='hidden wow pulse h-full items-center justify-center lg:flex'>
                    <img className='h-auto w-full max-w-[400px] object-contain object-center xl:max-h-[500px] xl:max-w-[440px] 2xl:max-h-[540px] 2xl:max-w-[460px]' src={heroright} alt="A business profile with positive recommendations" />
                </div>
                </div>
            </section>

            <div className='w-full flex items-center relative overflow-x-auto'>
                {/* Left button */}
                {showLeft && (
                    <button
                    type="button"
                    aria-label="Scroll categories left"
                    onClick={() => scroll("left")}
                    className="absolute left-0 top-1/2 z-10 mt-1 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-white shadow-md transition hover:bg-[#F4F4F4]"
                    >
                    <img src={toleft} alt="" />
                    </button>
                )}
                <div ref={scrollRef} onScroll={checkScroll} className="w-full flex items-center space-x-4 overflow-x-auto scrollbar-hide my-5 lg:my-20">
                    {categories.map((category, index) => (
                        <button
                        type="button"
                        key={index}
                        onClick={() => navigateToCategory(category)}
                        className="flex h-20 w-48 flex-shrink-0 cursor-pointer flex-row items-center justify-start space-x-3 rounded-[6px] bg-[#F8F8F8] px-3 text-left transition hover:-translate-y-0.5 hover:bg-[#F0F0F0] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#008B39]"
                        >
                        <div className="text-3xl">{category.image?.originalUrl ? <img className='h-[20px] w-[20px]' src={category.image.originalUrl} alt="" /> : <span className="inline-block h-[20px] w-[20px]" />}</div>
                        <p className="text-sm font-medium">{category? category.categoryName: ''}</p>
                        </button>
                    ))}
                </div>

                {/* Right button */}
                {showRight && (
                    <button
                    type="button"
                    aria-label="Scroll categories right"
                    onClick={() => scroll("right")}
                    className="absolute right-0 top-1/2 z-10 mt-1 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-white shadow-md transition hover:bg-[#F4F4F4]"
                    >
                    <img src={toright} alt="" />
                    </button>
                )}
            </div>
   
            <div className=''>
                {fetched ? 
                    cards.length > 0 ? 
                    <CustomCarousel
                    defaultItemsPerSlide={3}
                    defaultRows={3}
                    responsive={[
                        { breakpoint: 1024, itemsPerSlide: 1, rows: 10 },
                        { breakpoint: 768, itemsPerSlide: 2, rows: 2 },
                        { breakpoint: 480, itemsPerSlide: 2, rows: 3 },
                    ]}
                    >
                        {cards.map((item, index) => (
                            <Card key={index} className="" {...item}></Card>
                        ))}
                    </CustomCarousel> : <div className='font-semibold text-[20px]'>No results fetched, please check your internet or refresh.</div>
                :
                <div className='items-center grid mx-auto w-[80px] h-[80px] text-center'>
                <ColorRing
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="color-ring-loading"
                    wrapperStyle={{}}
                    wrapperClass="color-ring-wrapper"
                    colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                    className="mx-auto"
                    />
                </div>

                } 
            </div>

            <div className='pb-10 lg:pb-20 lg:pt-20'>
                <div className="relative aspect-video w-full overflow-hidden rounded-[8px] bg-black">
                    <iframe
                    className="absolute top-0 left-0 h-full w-full"
                    src="https://www.youtube.com/embed/LtgUaxGIrc8"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    ></iframe>
                </div>
            </div>
            {/* <div className=' mt-5 lg:mt-20'>
                <Advert></Advert>
            </div>   */}
        </div>
    );
}

export default HomeBody;